// extracted by mini-css-extract-plugin
export default {"download-button":"styles_download-button__vzgYb"};